<app-menu>
    <mat-card>
        <div class="grid-header">
            <div class="grid-title">&nbsp;&nbsp;Key Performance Indicator Report</div>
            <div class="toolbar-actions">
              <div class="search-container">
                <button (click)="exceptionReports()" style="background-color: rgb(2, 71, 10); " mat-raised-button color="primary">Exception Report</button>&nbsp;
                <button (click)="storeReports()" style="background-color: rgb(2, 71, 10); " mat-raised-button color="primary">Store Report</button>&nbsp;
                <button (click)="deliveryReports()" style="background-color: rgb(2, 71, 10); " mat-raised-button color="primary">Delivery Report</button>&nbsp;
              </div>
            </div>      
          </div>  
        <br>
        <mat-card-content>
            <mat-button-toggle-group value="pickup" (change)="onToggleButtonChange($event)"
                #group="matButtonToggleGroup">
                <mat-button-toggle value="pickup" style="background-color:rgb(2, 71, 10); color: white">Filter By Pick-up Date</mat-button-toggle>
                <mat-button-toggle value="delivery" style="background-color:rgb(2, 71, 10); color: white">Filter By Delivery Date</mat-button-toggle>
            </mat-button-toggle-group>
            <br><br>
            <div [formGroup]="reports_form" style="display: flex ; justify-content: space-start; flex-wrap: wrap;">
                <span *ngIf="group.value == 'pickup'"
                    style="flex-basis: 60%; display: flex; justify-content: space-between;">
                    <mat-form-field style="width: 45%;">
                        <mat-label>Pick-up Date (From):</mat-label>
                        <input matInput formControlName="pickup_from" [matDatepicker]="picker1">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field style="width: 45%;">
                        <mat-label>Pick-up Date (To):</mat-label>
                        <input matInput formControlName="pickup_to" [matDatepicker]="picker2">
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </span>
                <span *ngIf="group.value == 'delivery'"
                    style="flex-basis: 60%; display: flex; justify-content: space-between;">
                    <mat-form-field style="width: 45%;">
                        <mat-label>Delivery Date (From):</mat-label>
                        <input matInput formControlName="delivery_from" [matDatepicker]="picker3">
                        <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                        <mat-datepicker #picker3></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field style="width: 45%;">
                        <mat-label>Delivery Date (To):</mat-label>
                        <input matInput formControlName="delivery_to" [matDatepicker]="picker4">
                        <mat-datepicker-toggle matIconSuffix [for]="picker4"></mat-datepicker-toggle>
                        <mat-datepicker #picker4></mat-datepicker>
                    </mat-form-field>
                </span>
            </div>
            <div style="width: 50%; display: flex; justify-content: flex-start; gap: 20px">
                <!-- Search Button -->
                <button (click)="search()" mat-raised-button color="primary" style="background-color:rgb(2, 71, 10);">
                  <i class="fa-solid fa-magnifying-glass"></i>
                  <span class="text">Search</span>
                </button>
              
                <!-- Reset Button -->
                <button mat-raised-button (click)="resetFilter()"  mat-raised-button color="primary" style="background-color:rgb(2, 71, 10);">
                  <i class="fas fa-undo"></i>
                  <span class="text">Reset</span>
                </button>
              
                <!-- Export CSV Button -->
                <button (click)="exportToCSV()"  mat-raised-button color="primary" style="background-color:rgb(2, 71, 10);">
                  <i class="fa-solid fa-file-csv"></i>
                  <span class="text">Export CSV File</span>
                </button>
              
                <!-- Export Excel Button -->
                <button  mat-raised-button color="primary" style="background-color:rgb(2, 71, 10);" (click)="exportToExcel()">
                  <i class="fas fa-file-excel"></i>
                  <span class="text">Export Excel File</span>
                </button>
              </div>
        </mat-card-content>
    </mat-card>
    <ag-grid-angular 
        #agGrid style="width: 100%; height: 100%;" 
        class="ag-theme-balham" 
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)" 
        [defaultColDef]="defaultColDef">
    </ag-grid-angular>
</app-menu>